// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4af9f8a9","488":"476cbffc"}[chunkId] + ".chunk.js";
};